module.exports = function() {
  return new Worker(__webpack_public_path__ + "66bc141dd515a5b2f5a5.worker.js");
};